/**
 * Client configuration. Physics runs in the original native 735x375 space;
 * we render scaled up for crisp modern displays.
 */
import { FIELD_WIDTH, FIELD_HEIGHT } from '@jgolf/shared';

function colyseusUrl(): string {
  const env = import.meta.env.VITE_COLYSEUS_ENDPOINT;
  if (env) return env;
  if (import.meta.env.PROD) return window.location.origin;
  const host = window.location.hostname || 'localhost';
  return `http://${host}:2567`;
}

export const RENDER_SCALE = 2;

export const CONFIG = {
  COLYSEUS_URL: colyseusUrl(),
  API_BASE: '', // relative; dev proxied by Vite, prod same-origin
  FIELD_WIDTH,
  FIELD_HEIGHT,
  GAME_WIDTH: FIELD_WIDTH * RENDER_SCALE,
  GAME_HEIGHT: FIELD_HEIGHT * RENDER_SCALE,
  BALL_COLORS: [0xffffff, 0xffd34e, 0x5ec8ff, 0xff7a7a],
} as const;

export const toScreen = (n: number): number => n * RENDER_SCALE;
export const toNative = (n: number): number => n / RENDER_SCALE;
